import CommunicationMode from './CommunicationMode';

export default class AddressCommunicationMode extends CommunicationMode {
  constructor({
    id,
    value = undefined,
    comment = undefined,
    mode = undefined,
    sortOrder = undefined,
  }) {
    super({
      id,
      value,
      comment,
      mode,
      sortOrder,
    });
  }

  static get apiRoute() {
    return 'address_communication_mode_data';
  }

  static get joinAttrsKey() {
    return CommunicationMode.joinAttrsKey;
  }

  static get allAttributes() {
    return CommunicationMode.allAttributes;
  }
}
